"use client";

import { type GameFilterGroup, GameFilterPanel } from "@workspace/frontend-ui";
import useFilterSelect from "./useFilterSelect";

type Props = {
  title: string;
  groups: GameFilterGroup[];
};

const FiltersAside: FC<Props> = ({ title, groups }) => {
  const { select } = useFilterSelect(groups);

  return (
    <div
      data-testid="all-games-filters-aside"
      className="hidden w-95 lg:col-start-2 lg:row-start-2 lg:block"
    >
      <GameFilterPanel
        title={title}
        groups={groups}
        selectAction={select}
        className="no-scrollbar sticky top-6 max-h-[calc(100dvh-6rem)] overflow-y-auto"
      />
    </div>
  );
};

export default FiltersAside;
